<template>
    <div>
        <profile-settings-module></profile-settings-module>
    </div>
</template>

<script>import ProfileSettingsModule from './partials/ProfileSettingsModule';
    export default {
        components: {
            'profile-settings-module': ProfileSettingsModule,
        },
        data() {
            return {

            }
        }
    }</script>

<style lang="scss" scoped>

</style>
